import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=a2938b24&"
import script from "./SideNav.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideNav.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SideNav.vue?vue&type=style&index=0&id=a2938b24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports